// extracted by mini-css-extract-plugin
module.exports = {"controls":"controls--PH95p"};